import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Service from '../components/Service';
import News from '../components/News';
import Portfolio from '../components/Portfolio';
import Documents from '../components/Documents';
import Clients from '../components/Clients';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Home = () => {
  return (
    <>
      <Header />
      <Hero />
      <main id="main">
        <About />
        <Service />
        <News />
        <Portfolio />
        <Documents />
        {/* <Features />
         เพิ่มส่วนอื่นๆ ของ template ที่นี่*/}
         <Clients />
         <Contact />
      </main> 
      <Footer />
      
    </>
  );
};

export default Home;